import { render, staticRenderFns } from "./CoveragePillsGroupWrapper.vue?vue&type=template&id=6895363a&scoped=true&lang=pug&"
import script from "./CoveragePillsGroupWrapper.vue?vue&type=script&lang=js&"
export * from "./CoveragePillsGroupWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6895363a",
  null
  
)

export default component.exports